import { Guid } from '@Shared.Angular/@types/guid';

export interface IStakeholderRefPascalCase {
  Id: Guid;
  Name: string;
}

export interface IStakeholderSectionPascalCase {
  Users: IStakeholderRefPascalCase[];
  Teams: IStakeholderRefPascalCase[];
}

export interface IStakeholdersPascalCase {
  Responsible: IStakeholderSectionPascalCase | null;
  Accountable: IStakeholderSectionPascalCase | null;
  Consulted: IStakeholderSectionPascalCase | null;
  Informed: IStakeholderSectionPascalCase | null;
}

export const emptyStakeholderSection = (): IStakeholderSectionPascalCase => ({
  Users: [],
  Teams: []
});

export const emptyStakeholders = (): IStakeholdersPascalCase => ({
  Responsible: emptyStakeholderSection(),
  Accountable: emptyStakeholderSection(),
  Consulted: emptyStakeholderSection(),
  Informed: emptyStakeholderSection()
});
